<div class="nav-save nav-button" [class.fa-disabled]="!isDirty" [class.save-active]="isDirty" (click)="dashboardsSave()"
    title="{{ 'Save' | i18next }}">
    <i class="fal fa-save" tabindex="0"></i>
</div>
<div class="nav-button" [class.fa-disabled]="!isDirty" (click)="dashboardsCancel()" title="{{ 'Cancel' | i18next }}">
    <img src="assets/Img/discard_changes.svg" tabindex="0">
</div>
<div class="nav-button" [matMenuTriggerFor]="isReadOnly?null:addMenu" title="{{ 'dashboard:Add dashboard' | i18next }}"
    [class.fa-disabled]="isReadOnly" [attr.disabled]="!isReadOnly ? null : true">
    <i class="fal fa-plus" tabindex="0"></i>
</div>
<button class="nav-button"
    [class.fa-disabled]="((dashboards$ | async).filter(dashboardVisible).length<=1) || !isActiveDashboardEditable"
    (click)="dashboardRemoveActive()" [attr.disabled]="isActiveDashboardEditable ? null : true"
    title="{{ 'dashboard:Delete current dashboard' | i18next }}">
    <i class="fal fa-trash-alt" tabindex="0"></i>
</button>
<button class="nav-button" [class.fa-disabled]="!isAllowedToChangeAccess(activeDashboard)"
    [attr.disabled]="isAllowedToChangeAccess(activeDashboard) ? null : true" [matMenuTriggerFor]="accessMenu"
    title="{{ 'dashboard:Change access of current dashboard' | i18next }}">
    <i class="fal fa-eye" tabindex="0"></i>
</button>
<button class="nav-button" title="{{ 'dashboard:Filter dashboards' | i18next }}" (click)="dashboardsFilter()">
    <i class="fal fa-filter" tabindex="0"></i>
</button>
<div class="nav-corner-container">
    <div class="nav-corner"> </div>
</div>

<nav mat-tab-nav-bar #matTab>
    <ng-container *ngFor="let dashboard of dashboards$| async">
        <div *ngIf="dashboard.visible">
            <!-- <form (ngSubmit)="dashboardSaveEdit($event,dashboard)" (keyup.enter)="dashboardSaveEdit($event,dashboard)"
                (keydown.esc)="dashboardAbordEdit($event)" class="mat-tab-link"
                *ngIf="dashboard.id==editDashId && dashboard.id == (selectedDashboard$ | async)"> -->
            <input mat-tab-link name="dash_name"
                *ngIf="dashboard.id==editDashId && dashboard.id == (selectedDashboard$ | async)" class="dashboard-edit"
                [value]="dashboard.name" maxlength="40" (keyup.enter)="dashboardSaveEdit($event,dashboard)"
                (keydown.esc)="dashboardAbordEdit($event)" [size]="dashboard.name.length"
                (blur)="dashboardEditBlur($event,dashboard)" [(ngModel)]="editName">
            <!-- </form> -->
            <a mat-tab-link (click)="selectDashboard(dashboard)"
                *ngIf="!(dashboard.id==editDashId && dashboard.id == (selectedDashboard$ | async))"
                (dblclick)="dashboardEdit($event,dashboard)" [active]="dashboard.id == (selectedDashboard$ | async)">
                {{ dashboard.name }}
                <span>
                    <dashboard-access-icon [dashboard]="dashboard"></dashboard-access-icon>
                </span>
            </a>
        </div>
    </ng-container>
</nav>
<mat-menu #addMenu="matMenu" xPosition="before" class="nav-menu">
    <button mat-menu-item (click)="dashboardAdd($event)" class="add-menu-button"
        [class.link-disabled]="(dashboards$|async).filter(userOwned)?.length >= maxDashboards">
        <i class="fal fa-table"></i><span></span> {{ 'dashboard:Add dashboard' | i18next }}
    </button>
    <button mat-menu-item
        [routerLink]="isActiveDashboardEditable && ((activeTabWidgets$|async)?.length < maxWidgets) ? '/dashboard/wizard/' : null"
        class="add-menu-button"
        [class.link-disabled]="!(isActiveDashboardEditable && ((activeTabWidgets$|async)?.length < maxWidgets))">
        <i class="far fa-chart-bar"></i> {{ 'dashboard:Add widget' | i18next }}
    </button>
</mat-menu>

<mat-menu #accessMenu="matMenu" xPosition="before" class="nav-menu nav-menu-access">
    <div mat-menu-item class="access-menu-button">
        <mat-radio-button (click)="updateDashboardAccess($event, false)" [checked]="!activeDashboard.isPublic">{{
            'dashboard:Private' | i18next }} <img class="menu-access-icon-lock"
                src="assets/Img/Main/dashboard_access/Private.svg" /></mat-radio-button>
        <!-- <input type="radio" id="access_private" name="access" [(ngModel)]="activeDashboard.isPublic" [value]="false"
            (change)="updateDashboardAccess($event, false)" />
        <label for="access_private" class="menu-access-lable">
            {{ 'dashboard:Private' | i18next }}
            <img class="menu-access-icon-lock" src="assets/Img/Main/dashboard_access/Private.svg" />
        </label> -->
    </div>
    <hr />
    <div mat-menu-item class="access-menu-button">
        <mat-radio-button (click)="updateDashboardAccess($event, true)" [checked]="activeDashboard.isPublic">{{
            'dashboard:Company' | i18next }} <img class="menu-access-icon-dark-persons"
                src="assets/Img/Main/dashboard_access/Company.svg" /></mat-radio-button>
        <!-- <input type="radio" id="access_public" name="access" [(ngModel)]="activeDashboard.isPublic" [value]="true"
            (change)="updateDashboardAccess($event, true)" />
        <label for="access_public" class="menu-access-lable">
            {{ 'dashboard:Company' | i18next }}
            <img class="menu-access-icon-dark-persons" src="assets/Img/Main/dashboard_access/Company.svg" />
        </label> -->
    </div>
    <div class="access-menu-button" (click)="allowOtherToEditClick($event)">
        <mat-slide-toggle color="Primary" [(ngModel)]="activeDashboard.allowNonOwnersToEdit" id="allow_others"
            (change)="updateAllowNonOwnersToEdit($event)" [disabled]="!activeDashboard.isPublic">{{ 'dashboard:Allow
            others to edit this Dashboard' | i18next }}</mat-slide-toggle>
    </div>
</mat-menu>